import { useMediaQuery } from "@ffn/app-kit"
import { Display, Eyebrow, Prose, Section } from "@ffn/components"
import { createFileRoute, Link } from "@tanstack/react-router"
import { AboutTerminal } from "../features/AboutTerminal.js"
import { Bio } from "../features/Bio.js"
import { Links } from "../features/Links.js"
import { aboutHead } from "../seo/index.js"
import "../content.css"

export const Route = createFileRoute("/about")({ head: aboutHead, component: AboutPage })

function AboutPage() {
  const wide = useMediaQuery("(min-width: 60rem)")
  return (
    <Section className="SiteSection SiteAbout">
      <Eyebrow>About</Eyebrow>
      <Display>About Laith Al-Saadoon</Display>
      <div className="SiteAboutTerminalTop">
        <AboutTerminal animate={wide} />
      </div>
      <Bio />
      <Prose>
        <p>
          The <Link to="/notes">Frontier Field Notes</Link> are where the work gets written up:
          long-form essays and short side quests.
        </p>
      </Prose>
      <Links />
      <details className="SiteTerminalDetails">
        <summary>The short version, in a terminal</summary>
        <AboutTerminal />
      </details>
    </Section>
  )
}
